import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import {setTheme} from 'ngx-bootstrap/utils';
import { OnInit } from '@angular/core';
import {ResponsiveService} from './services/responsive.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'falaExtranet';

  dateLastConnection ='Ultima conexión 23/08/2020';
  public minDate: Date = new Date ("05/07/2017 2:00 AM");
  public maxDate: Date = new Date ("05/27/2017 11:00 AM");
  public dateValue: Date = new Date ("05/16/2017 5:00 AM");

  constructor(private responsiveService:ResponsiveService, private renderer: Renderer2){
    setTheme('bs3');   
    localStorage.setItem('timeLeft', '300');
    
  }

  ngOnInit(){
    this.onResize();    
    window.addEventListener("dragover", e => {
      e && e.preventDefault();
    }, false);
    window.addEventListener("drop", e => {
      e && e.preventDefault();
    }, false);
  }   
  
  onResize(){
    this.responsiveService.checkWidth();
  }

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }
}
